import React from "react";
import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import useCreditBalance from "./useCreditBalance";

const CreditBalance = ({ subscription, handleClose, refetch }) => {
  const { formik, isCrediting, getFieldError } = useCreditBalance(
    subscription,
    handleClose,
    refetch
  );

  return (
    <div>
      <h5 className="pro-ttl pro-mb-2">Credit {subscription?.plan_name}</h5>
      {/*
        The manual fallback for a void the POS never reported. It is recorded under its own
        ledger type against the admin who did it, so it is always distinguishable from a
        credit the webhook made.
      */}
      <p className="pro-font-sm pro-mb-2">
        {subscription?.subscription_code} — {subscription?.remaining_items} of{" "}
        {subscription?.total_items} items left. Use this when an order was voided
        but no webhook arrived.
      </p>

      {/*
        Named before the button rather than after it: this hands a customer a free beverage,
        and the row it was opened from carries only a plan name that dozens of people hold.
      */}
      <div className="pro-p-3 pro-mb-4 pro-bg-light rounded-3">
        <span className="pro-font-sm">Crediting</span>
        <p className="pro-mb-0 pro-fw-medium">
          {subscription?.customer_name ?? "Unnamed customer"}
          {subscription?.customer_mobile
            ? ` · ${subscription.customer_mobile}`
            : ""}
        </p>
      </div>

      <Input
        label={"Items to credit back"}
        type="number"
        id="quantity"
        name="quantity"
        className={`pro-input lg ${getFieldError("quantity") && " error"}`}
        {...formik.getFieldProps("quantity")}
        error={getFieldError("quantity")}
        errorMessage={getFieldError("quantity")}
      />

      <Input
        label={"Order ID (optional)"}
        type="text"
        id="order_id"
        name="order_id"
        className={`pro-input lg ${getFieldError("order_id") && " error"}`}
        {...formik.getFieldProps("order_id")}
        error={getFieldError("order_id")}
        errorMessage={getFieldError("order_id")}
      />

      <div className="input-wrap pro-mb-4">
        <label htmlFor="reason" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Reason
        </label>
        <textarea
          id="reason"
          name="reason"
          rows={3}
          className={`pro-input lg ${getFieldError("reason") && " error"}`}
          {...formik.getFieldProps("reason")}
        />
        {getFieldError("reason") && (
          <span className="error-text">{getFieldError("reason")}</span>
        )}
      </div>

      <div className="pro-d-flex pro-justify-end">
        <Button className={"pro-btn-link lg pro-px-5"} onClick={handleClose}>
          Back
        </Button>
        <Button
          className={`pro-btn-primary lg pro-ms-3`}
          type="submit"
          onClick={formik.handleSubmit}
          disabled={isCrediting}
        >
          {isCrediting ? "Crediting..." : "Credit Balance"}
        </Button>
      </div>
    </div>
  );
};

export default CreditBalance;
